import { DateTime } from "@grapecity/wijmo";
import { useMutation } from "@tanstack/react-query"
import { getPreliquidateOvertimeListByUser } from "../api/liquidateApi";

export const useGetPreliquidateOvertimeListByUser = () => {
    return useMutation({
        mutationFn: ({startDate, endDate} : {
            startDate: DateTime,endDate : DateTime
        }) => getPreliquidateOvertimeListByUser(startDate, endDate)
    });
}